import React from "react";
import { LogRenderContext } from "../LogRenderer";
import Cancelled from "../common/Cancelled";
import { getMediaDetails } from "../utils";

const MediaCancelled = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, id, updatedBy, updatedAt } = getMediaDetails(log);
  return <Cancelled name={name} id={id} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default MediaCancelled;
